import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    '@keyframes fadeInWidgets': {
        '0%': {
            transform: 'translateY(-30px)',
            transition: 'transform 2s',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
    animateWidgetLinks: {
        opacity: 0,
        animation: '$fadeInWidgets 1s forwards 1.5s',
    },
    animateCadenzaLinks: {
        opacity: 0,
        animation: '$fadeInWidgets 1s forwards 1.8s',
    },
    animateTribute: {
        opacity: 0,
        animation: '$fadeInWidgets 1s forwards 2s',
    },
    container: {
        width: '100%',
        height: 'auto',
        boxSizing: 'border-box',
        backgroundColor: theme.colors.dark.dark1,
        color: theme.colors.white,

        '@media (min-width: 1268px)': {
            display: 'flex',
            justifyContent: 'space-between',
        },
    },
    wideColumn: {
        boxSizing: 'border-box',
        width: '100%',
        height: 'auto',
        padding: 20,
        order: 1,
        display: 'flex',
        flexDirection: 'column',

        '@media (min-width: 1268px)': {
            maxWidth: '70%',
            marginRight: 80,
        },
    },
    narrowColumn: {
        boxSizing: 'border-box',
        width: '100%',
        height: 'auto',
        padding: 20,
        order: 2,
        display: 'flex',
        flexDirection: 'column',

        '@media (min-width: 1268px)': {
            maxWidth: '25%',
        },
    },
    hideInMobile: {
        '@media (max-width: 767px)': {
            display: 'none',
        },
    },
    fullWidth: {
        width: '100%',
        maxWidth: '100%',
        marginRight: 0,
    },
}))
